document.addEventListener("DOMContentLoaded", () => {
  const countdownEl = document.querySelector(".lead-header__countdown");
  const buttonEl = document.querySelector(".lead-header__button");

  if (!countdownEl) return;

  const endDate = countdownEl.dataset.endDate;
  const endTime = countdownEl.dataset.endTime;

  if (!endDate || !endTime) return;

  // Creamos un objeto Date de la fecha/hora de fin
  const endDateTime = new Date(`${endDate}T${endTime}`);

  function updateCountdown() {
    const now = new Date();
    const remaining = endDateTime - now;

    if (remaining <= 0) {
      countdownEl.textContent = "Offer ended";

      if (buttonEl) {
        buttonEl.style.pointerEvents = "none";
        buttonEl.style.opacity = "0.5";
      }
      return; // fin del countdown
    }

    const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
    const hours = Math.floor((remaining / (1000 * 60 * 60)) % 24);
    const mins = Math.floor((remaining / (1000 * 60)) % 60);
    const secs = Math.floor((remaining / 1000) % 60);

    // Mostramos el countdown dinámico
    countdownEl.textContent =
      (days > 0 ? days + "d " : "") +
      String(hours).padStart(2, "0") + "h " +
      String(mins).padStart(2, "0") + "m " +
      String(secs).padStart(2, "0") + "s";

    requestAnimationFrame(updateCountdown);
  }

  updateCountdown();
});
